import { render, staticRenderFns } from "./actualData.vue?vue&type=template&id=12734446&"
import script from "./actualData.vue?vue&type=script&lang=js&"
export * from "./actualData.vue?vue&type=script&lang=js&"
import style0 from "./actualData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports